import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";


const CustomCaptcha = ({disabilitaInvia, changeDisabilitaInvia}) => {
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [userInput, setUserInput] = useState("");
 

  // Genera un CAPTCHA casuale
  function generateCaptcha() {
    return Math.floor(1000 + Math.random() * 9000).toString(); // Numero di 4 cifre
  }

  // Verifica il CAPTCHA
  const validateCaptcha = () => {
    if (userInput === captcha) {
      changeDisabilitaInvia(true)
    } else {
      changeDisabilitaInvia(false)
      setCaptcha(generateCaptcha()); // Rigenera un nuovo CAPTCHA
      setUserInput(""); // Resetta il campo di input
    }
  };

  return (
    <>
      <div className="p-field">
        <p>Per poter inviare il preventivo, inserisci il seguente numero:</p>
        <h3 className="p-mb-3">{captcha}</h3>
        <InputText
          value={userInput}
          onChange={(e) => setUserInput(e.target.value)}
          placeholder="Inserisci il CAPTCHA"
          className="p-mb-3"
        />
      </div>
      <Button label="Verifica" icon="pi pi-check" onClick={validateCaptcha} className="p-mb-3" />
      {disabilitaInvia  === true  && <p className="p-text-success">CAPTCHA valido! 🎉</p>}
      {disabilitaInvia ===  false && <p className="p-text-danger">CAPTCHA non valido. Riprova. ❌</p>}
     </>
  );
};

export default CustomCaptcha;
